import SentryMiddleware from 'redux-sentry-middleware';
import * as Sentry from '@sentry/browser';

export default SentryMiddleware(Sentry, {});
